export const basic4 = () => ({
  type: 'page',
  meta: {
    id: 'doc:home',
    title: '4 selection page',
    createDate: 1706097560407,
    tags: [],
  },
  blocks: {
    type: 'block',
    id: '3DuFbgqrNR',
    flavour: 'affine:page',
    version: 2,
    props: {
      title: {
        '$blocksuite:internal:text$': true,
        delta: [
          {
            insert: '4 selection page',
          },
        ],
      },
    },
    children: [
      {
        type: 'block',
        id: 'mOue8GxTgX',
        flavour: 'affine:surface',
        version: 5,
        props: {
          elements: {
            aFOvQtnxse: {
              index: 'a2',
              seed: 1511317069,
              xywh: '[-344.30956881823494,24.692458710023665,192.2879180908203,45]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section1.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 32,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'aFOvQtnxse',
              hasMaxWidth: false,
            },
            cE_4keBrSs: {
              index: 'a3',
              seed: 1511317069,
              xywh: '[661.6571733045968,-34.58570995204728,202,45]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section3.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 32,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'cE_4keBrSs',
              hasMaxWidth: false,
            },
            PohTf1UN5h: {
              index: 'a4',
              seed: 1511317069,
              xywh: '[647.7582958318535,450.7896054491542,203,45]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section4.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 32,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'PohTf1UN5h',
              hasMaxWidth: false,
            },
            zgnMEowTL8: {
              index: 'a5',
              seed: 1511317069,
              xywh: '[-344.3095688182349,390.57221414480637,201,45]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section2.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 32,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'zgnMEowTL8',
              hasMaxWidth: false,
            },
          },
        },
        children: [
          {
            type: 'block',
            id: 'Z6mrCnW6gB',
            flavour: 'affine:image',
            version: 1,
            props: {
              caption: 'background',
              sourceId: 'HXC90UUACyvyPfqKEpctdN9yS-HdCT67v5qPMscJ0dM=',
              width: 1920,
              height: 1080,
              index: 'a0',
              xywh: '[-470.01407471479627,-191.51244458281522,1920,1080]',
              rotate: 0,
              size: 41346,
            },
            children: [],
          },
          {
            type: 'block',
            id: 'Y93dOLO2zM',
            flavour: 'affine:frame',
            version: 1,
            props: {
              title: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'title',
                  },
                ],
              },
              background: '--affine-palette-transparent',
              xywh: '[-510.01407471479627,-231.51244458281522,2000,1160]',
              index: 'a0',
            },
            children: [],
          },
          {
            type: 'block',
            id: 'bYnNcnSJO3',
            flavour: 'affine:image',
            version: 1,
            props: {
              caption: 'section1.image',
              sourceId: 'kG7TkqZ8THlctv4JLz-ghn38lAjIV0c9jXLVQ5021js=',
              width: 0,
              height: 0,
              index: 'a1zV',
              xywh: '[259.0570046702425,-143.24732715733307,308.9261751846594,983.4697651490358]',
              rotate: 0,
              size: -1,
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: 'eCCqi25Afm',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[-370.61047183429827,84.90985001437149,580.2352933407334,213.40107180917565]',
          background: '--affine-palette-transparent',
          index: 'a1V',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1.2010374786092506,
            collapse: true,
            collapsedHeight: 177.68060998086824,
          },
        },
        children: [
          {
            type: 'block',
            id: 'WlW18x5g5q',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section1.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: 'Z3Wh0jxQM-',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[617.4153630187093,-20.596864955022994,747.7574310678956,257.6858350757561]',
          background: '--affine-palette-transparent',
          index: 'a1l',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1.7450255620809119,
            collapse: true,
            collapsedHeight: 147.6688024950593,
          },
        },
        children: [
          {
            type: 'block',
            id: 'g0jCxeI9qG',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section3.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: '4fpNNVMmbx',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[606.7357563315518,466.9043931494709,769.1166444422106,284.8337116375557]',
          background: '--affine-palette-transparent',
          index: 'a1t',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1.657333562935916,
            collapse: true,
            collapsedHeight: 171.86263405719092,
          },
        },
        children: [
          {
            type: 'block',
            id: 'vf9O3-_wNA',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section4.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: 'rWJ4-nDu_V',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[-370.6104718342982,450.7896054491542,580.7124487150616,213.40107180917565]',
          background: '--affine-palette-transparent',
          index: 'a1x',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1.2010374786092506,
            collapse: true,
            collapsedHeight: 177.68060998086824,
          },
        },
        children: [
          {
            type: 'block',
            id: 'GCtWbibEn8',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section2.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
    ],
  },
});
